document.addEventListener('turbolinks:load', () => {

  $(".flash_show").delay(3000).slideUp();

  try {
    let target = document.getElementById('message_scroll');
    target.scrollIntoView(false);
  } catch (err) {

  }

  var height=window.innerHeight;
  document.documentElement.style.setProperty( '--vh', height/100 + 'px');

  var width=window.innerWidth;
  document.documentElement.style.setProperty( '--vw', width/100 + 'px');
  
  window.addEventListener('orientationchange', () => {
    var height=window.innerHeight;
    document.documentElement.style.setProperty( '--vh', height/100 + 'px');
  
    var width=window.innerWidth;
    document.documentElement.style.setProperty( '--vw', width/100 + 'px');
  
  });

  window.addEventListener('resize', () => {
    var height=window.innerHeight;
    document.documentElement.style.setProperty( '--vh', height/100 + 'px');
  
    var width=window.innerWidth;
    document.documentElement.style.setProperty( '--vw', width/100 + 'px');
  
  });
  
})
